// src/config.js
// In production the API is exposed through the frontend origin (see vercel.json).
// This keeps the httpOnly session cookie first-party, which is required when the
// browser blocks third-party cookies (notably Chrome's incognito mode).
const USE_SAME_ORIGIN_API_PROXY =
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_DISABLE_API_PROXY !== "true";
const RAW_API_URL = USE_SAME_ORIGIN_API_PROXY
  ? "/backend-api"
  : process.env.REACT_APP_API_URL || "http://localhost:5000";
const NORMALIZED_URL = RAW_API_URL.replace(/\/+$/, "");
export const API_URL = NORMALIZED_URL === "" ? "http://localhost:5000" : NORMALIZED_URL;
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || "default-tenant-legacy";

